import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Select from './Select';

import { Storage } from '../../../utils/Storage';
import { selectAvailableLanguages, saveLanguage, applyLanguage } from '../../../store/languageSlice';

export default function LanguageSwitcher(props) {
    const { sx = {} } = props;
    const dispatch = useDispatch();
    const { i18n } = useTranslation();
    const availableLanguages = useSelector(selectAvailableLanguages);

    const handleSelect = (event) => {
        const lang = event.target.value;
        if (Storage.getAuthToken()) {
            dispatch(saveLanguage(lang));
        } else {
            dispatch(applyLanguage(lang));
        }
    };

    if (Object.keys(availableLanguages).length <= 1) return null;

    return (
        <Select
            sx={{ minWidth: 80, ...sx }}
            size="small"
            id="language"
            label=""
            value={i18n.language?.slice(0, 2) || ''}
            onChange={handleSelect}
            options={Object.entries(availableLanguages).map(([code, label]) => ({ id: code, name: label }))}
        />
    );
}
